export default defineNuxtRouteMiddleware((to) => {
	if (to.query.st) {
		return navigateTo({ name: 'MerchantV1Signin', query: { token: to.query.st } });
	}
});
